<template>
    <div>
        <div>
            <div class="header" style="margin-bottom: 0.5em;font-size: 1.125em;line-height: 1.5em;">
                {{aoi.label}}
            </div>
            <div style="color: rgb(208, 208, 208);">
                <div>
                    <p style="margin-bottom: 2px">
                        {{formatCoords(aoi.center)}}
                    </p>
                    <p>
                        {{formatDate(aoi.start)+" — "+formatDate(aoi.end)}}
                    </p>
                </div>
            </div>
        </div>
        <div style="padding-right: 15px;padding-bottom: 10px;margin-top: 15px;display: flex;align-items: center">
            <div>
                <user-avatar :style="{width: '28px',height:'28px'}"
                             :img="aoi.userData.photoURL"
                />
            </div>
            <div style="padding-left: 10px">
                <div class="header"
                     style="margin-bottom: 0; font-size: 0.9em;  font-weight: 500;color: rgb(158, 157, 157)">
                    {{aoi.userData.displayName}}
                </div>
            </div>
            <p style="font-size: 0.85em;margin-left: auto;color: rgb(158, 157, 157)">
                {{formatTime(aoi.creationTime)}}
            </p>
        </div>

        <div style="display: flex" :style="{'align-items':aoi.status==='done'?'center':undefined}">
            <status-chip :status="aoi.status"/>
            <div v-if="aoi.status==='rejected'&&aoi.statusMessage"
                 style="color: rgb(255, 109, 109);margin-left: 5px;margin-top: 5px">
                <p style="padding-left: 5px">
                    {{aoi.statusMessage}}
                </p>
            </div>

            <v-btn v-if="aoi.status==='done'"
                   flat icon color="grey lighten-2"
                   title="Скачать снимок"
                   @click.stop="onDownloadResultButtonClick">
                <v-icon>mdi-download</v-icon>
            </v-btn>
        </div>

        <div style="display: flex;justify-content: flex-end">
            <template v-if="!aoi.status||aoi.status==='created'">
                <v-btn small round color="grey darken-3" dark
                       :style="{'padding-left': '24px', 'padding-right': '24px'}"
                       @click.stop="onAcceptButtonClick"
                >
                    Принять
                </v-btn>
                <v-btn small round color="grey darken-3" dark
                       :style="{'padding-left': '16px', 'padding-right': '16px'}"
                       @click.stop="onRejectButtonClick"
                >
                    Отклонить
                </v-btn>
            </template>
            <template v-if="aoi.status==='inProcessing'">
                <v-btn small round color="grey darken-3" dark
                       :style="{'padding-left': '16px', 'padding-right': '16px','margin-top': '0px'}"
                       @click.stop="onRejectButtonClick"
                >
                    Отклонить
                </v-btn>
            </template>
            <template v-if="aoi.status==='sent'">
                <v-btn small round color="grey darken-3" dark
                       :style="{'padding-left': '24px', 'padding-right': '24px'}"
                       @click.stop="onAddResultButtonClick"
                >
                    Прикрепить снимок
                </v-btn>
                <v-btn small round color="grey darken-3" dark
                       :style="{'padding-left': '16px', 'padding-right': '16px'}"
                       @click.stop="onRejectButtonClick"
                >
                    Отклонить
                </v-btn>
            </template>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import moment from 'moment'

    moment.locale('ru');

    import {formatCoords} from '@/lib/common-util'

    import StatusChip from '@/components/status-chip/status-chip';

    import UserAvatar from '@/components/user-avatar/user-avatar'

    export default {
        props: {
            aoi: {
                type: Object,
                required: true
            }
        },
        data() {
            return {}
        },
        computed: {},
        methods: {
            formatDate(date) {
                return moment(date).format("DD MMMM YYYY");
            },
            formatTime(time) {
                return moment(time).format("DD.MM.YYYY HH:mm");
            },
            formatCoords(coords) {
                return formatCoords(coords);
            },
            onAcceptButtonClick() {
                this.$emit('acceptButtonClick', this.aoi.id);
            },
            onRejectButtonClick() {
                this.$emit('rejectButtonClick', this.aoi.id);
            },
            onAddResultButtonClick() {
                this.$emit('addResultButtonClick', this.aoi.id);
            },
            onDownloadResultButtonClick() {
                this.$emit('downloadResultButtonClick', this.aoi.id);
            }
        },

        components: {
            UserAvatar,
            StatusChip
        }
    }
</script>

<style scoped>

</style>
